import React, { Component, useState, useEffect } from "react";
import dayjs from "dayjs";
import "./index.css";


const mapSize = {
  large: "ygs-picker-large",
  middle: "ygs-picker-middle",
  small: "ygs-picker-small",
};


const RangePickerInput = (props: {
  inputReadOnly?: boolean;
  placeholder?: string[];
  value?: [string, string];
  disabled?: boolean;
  allowClear?: boolean;
  showTime?: boolean;
  onChange?: (value: any) => void;
  style?: React.CSSProperties;
  className?: string;
  size?: "large" | "middle" | "small";
}) => {
  const {
    inputReadOnly,
    placeholder = ["开始日期", "结束日期"],
    value,
    disabled,
    allowClear,
    showTime,
    onChange = () => {},
    style = {},
    className = "",
    size = "middle" as keyof typeof mapSize,
  } = props;


  //   time: dayjs(new Date()).format("YYYY/MM/DD HH:mm:ss"),

  return (
    <div
      style={style}
      className={`ygs-picker ygs-picker-range ${mapSize[size]} ${className} ${
        disabled ? "ygs-picker-disabled" : ""
      }`}
    >
      <div className="ygs-picker-input ygs-picker-input-active">
        <input
          disabled={disabled}
          readOnly={inputReadOnly}
          placeholder={placeholder[0]}
          value={
            value && value[0]
              ? dayjs(value[0]).format(
                  showTime ? "YYYY/MM/DD HH:mm:ss" : "YYYY/MM/DD"
                )
              : ""
          }
        />
      </div>
      <div className="ygs-picker-range-separator">
        <span aria-label="to" className="ygs-picker-separator">
          <span
            role="img"
            aria-label="swap-right"
            className="anticon anticon-swap-right"
          >
            <svg
              viewBox="0 0 1024 1024"
              focusable="false"
              data-icon="swap-right"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z"></path>
            </svg>
          </span>
        </span>
      </div>
      <div className="ygs-picker-input">
        <input
          disabled={disabled}
          readOnly={inputReadOnly}
          placeholder={placeholder[1]}
          value={
            value && value[1]
              ? dayjs(value[1]).format(
                  showTime ? "YYYY/MM/DD HH:mm:ss" : "YYYY/MM/DD"
                )
              : ""
          }
        />
      </div>
      <div
        className="ygs-picker-active-bar"
        style={{ left: "0px", width: "165px", position: "absolute" }}
      ></div>
      <span className="ygs-picker-suffix">
        <span
          role="img"
          aria-label="calendar"
          className="anticon anticon-calendar"
        >
          <svg
            viewBox="64 64 896 896"
            focusable="false"
            data-icon="calendar"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"></path>
          </svg>
        </span>
      </span>

      {allowClear && !disabled ? (
        <span
          onClick={(event) => {
            event.preventDefault(); // 阻止表单提交的默认行为
            event.stopPropagation(); // 阻止事件冒泡
            onChange();
          }}
          className="ygs-picker-clear"
        >
          <span
            role="img"
            aria-label="close-circle"
            className="anticon anticon-close-circle"
          >
            <svg
              viewBox="64 64 896 896"
              focusable="false"
              data-icon="close-circle"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path>
            </svg>
          </span>
        </span>
      ) : null}
    </div>
  );
};

const DatePickerInput = (props :{
  inputReadOnly?: boolean;
  placeholder?: string;
  value?: string;
  disabled?: boolean;
  allowClear?: boolean;
  showTime?: boolean;
  onChange?: (value: any) => void;
  style?: React.CSSProperties;
  className?: string;
  size?: "large" | "middle" | "small";
}) => {
  const {
    inputReadOnly,
    placeholder = "请选择日期",
    value,
    disabled,
    allowClear,
    showTime,
    onChange = () => {},
    style = {},
    className = "",
    size = "middle" as keyof typeof mapSize,
  } = props;
  return (
    <div
      style={style}
      className={`ygs-picker ${mapSize[size]}  ${className}  ${
        disabled ? "ygs-picker-disabled" : ""
      }`}
    >
      <div className="ygs-picker-input">
        <input
          readOnly={inputReadOnly}
          placeholder={placeholder}
          defaultValue={
            value
              ? dayjs(value).format(
                  showTime ? "YYYY/MM/DD HH:mm:ss" : "YYYY/MM/DD"
                )
              : ""
          }
          value={
            value
              ? dayjs(value).format(
                  showTime ? "YYYY/MM/DD HH:mm:ss" : "YYYY/MM/DD"
                )
              : ""
          }
        />
        <span className="ygs-picker-suffix">
          <span
            role="img"
            aria-label="calendar"
            className="anticon anticon-calendar"
          >
            <svg
              viewBox="64 64 896 896"
              focusable="false"
              data-icon="calendar"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"></path>
            </svg>
          </span>
        </span>

        {allowClear && !disabled ? (
          <span
            className="ygs-picker-clear"
            role="button"
            onClick={(event) => {
              event.preventDefault(); // 阻止表单提交的默认行为
              event.stopPropagation(); // 阻止事件冒泡
              onChange();
            }}
          >
            <span
              role="img"
              aria-label="close-circle"
              className="anticon anticon-close-circle"
            >
              <svg
                viewBox="64 64 896 896"
                focusable="false"
                data-icon="close-circle"
                width="1em"
                height="1em"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path>
              </svg>
            </span>
          </span>
        ) : null}
      </div>
    </div>
  );
};

export { RangePickerInput, DatePickerInput };
